import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = ['badge'];
    static values = { initialLocale: String };

    connect() {
        // Backend sets current locale (app.request.locale injected into template as initialLocaleValue)
        let current = this.hasInitialLocaleValue
            ? this.initialLocaleValue
            : null;
        if (!current) {
            const checked = this.element.querySelector(
                'input[name="locale"]:checked',
            );
            current = checked ? checked.value : 'fr_FR';
        }
        this.updateBadge(current);
    }

    updateBadge(locale) {
        if (!this.hasBadgeTarget) return;
        const countryCode = locale === 'fr_CH' ? 'CH' : 'FR';
        const flag = locale === 'fr_CH' ? '🇨🇭' : '🇫🇷';
        this.badgeTarget.textContent = `${flag} ${countryCode}`;
    }

    onChange(event) {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || input.name !== 'locale')
            return;
        const locale = input.value;
        this.updateBadge(locale);
        const url = new URL(window.location.href);
        url.searchParams.set('switchLocale', locale);
        window.location.href = url.toString();
    }
}
